import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import installDesignSystemSelectorFallback from './utils/installDesignSystemSelectorFallback';

installDesignSystemSelectorFallback();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <App />
);
